import _ from 'lodash';
export function batchProxy(fn, delay = 1000) {
    const cache = [];
    let timer;
    let promise;
    return (codes) => {
        cache.push(...codes);
        if (timer) {
            return promise;
        }
        promise = new Promise((resolve, reject) => {
            timer = setTimeout(() => {
                fn(_.cloneDeep(cache))
                    .then(resolve)
                    .catch(reject);
                clearTimeout(timer);
                timer = null;
                cache.length = 0;
            }, delay);
        });
        return promise;
    };
}
